import authHeader from './auth-header';
import Api from './api';
import { JobStatus } from 'app/models/jobstatus';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class ApsReportService {  
  async generate(responseDownload: any) {
    return (await Api().post(`${API_URL}/apsReport/generate`, responseDownload, { headers:  authHeader() as any })).data;      
  }

  async getMetadata() {
    return await Api().get(`${API_URL}/apsReport/metadata`, { headers:  authHeader() as any });      
  }  
}

export default new ApsReportService();